module.exports = __webpack_public_path__ + "img/error-404-pin.f5251a89.svg";